
/* global krsCheckout:false, monerisCheckout:false, displayCheckoutPage:false */

(function ($) {

	$(document).ready(function () {

		krsCheckout = new monerisCheckout();
		krsCheckout.setMode("prod");
		krsCheckout.setCheckoutDiv("moneris-checkout");

		let receiptPagePath = "/receipt/";

		krsCheckout.setCallback("cancel_transaction", function(responseDataStr){
			console.log("CANCEL TRANSACTION");

			let responseData = JSON.parse(responseDataStr);
			console.log(responseData);
			window.location = receiptPagePath + "?cancelTXN";

		});

		krsCheckout.setCallback("error_event", function(responseDataStr){
			console.log("ERROR EVENT");

			let responseData = JSON.parse(responseDataStr);
			console.log(responseData);
			window.location = receiptPagePath + "?id=" + responseData.ticket;

		});

		krsCheckout.setCallback("payment_receipt", function(responseDataStr){
			console.log("PAYMENT RECEIPT");

			let responseData = JSON.parse(responseDataStr);
			console.log(responseData);
			window.location = receiptPagePath + "?id=" + responseData.ticket;

		});

		krsCheckout.setCallback("payment_complete", function(responseDataStr){
			console.log("PAYMENT COMPLETE");

			let responseData = JSON.parse(responseDataStr);
			console.log(responseData);
			window.location = receiptPagePath + "?id=" + responseData.ticket;

		});

	});

})(jQuery);

export let krsCheckout;

/* eslint-disable-next-line */
export function displayCheckoutPage(ticketNumber){

	jQuery(".image-set").closest(".wpb_raw_html").hide();

	jQuery(".moneris-checkout-wrap").addClass("show");

	krsCheckout.startCheckout(ticketNumber);

}